import React from 'react';
import {View} from 'react-native';
import {VisImpSwitchColor} from '../../../models/visuallyImpairedSettings';
import {Props} from './model';
import {VisuallyImpairedButton} from '../button';
import {getFontWeight} from '../../../theme/default';
import {useStyles} from '../../../hooks/styles';

export default ({onChange}: Props) => {
  const styles = useStyles(({theme, isDesktop}) => ({
    container: {
      flexDirection: 'row',
    },
    button: {
      width: 26,
      height: 30,
      marginLeft: 0,
      marginRight: 15,
      marginVertical: 0,
      borderWidth: 1,
      borderColor: isDesktop ? '#000000' : theme.color.black,
      paddingLeft: 2,
      paddingRight: 2,
    },
    whiteColorButton: {
      backgroundColor: '#FFFFFF',
    },
    blackColorButton: {
      backgroundColor: '#000000',
    },
    blueColorButton: {
      backgroundColor: '#9DD1FF',
    },
    buttonText: {
      fontWeight: getFontWeight('normal'),
      fontFamily: theme.fonts.fontFamily.regular,
      fontSize: 24,
      lineHeight: 28,
    },
    whiteColorButtonText: {
      color: '#000000',
    },
    blackColorButtonText: {
      color: '#FFFFFF',
    },
    blueColorButtonText: {
      color: '#000000',
    },
  }));

  return (
    <View style={styles.container}>
      <VisuallyImpairedButton
        label='А'
        onPress={() => onChange(VisImpSwitchColor.Normal)}
        style={[styles.button, styles.whiteColorButton]}
        textStyle={[styles.buttonText, styles.whiteColorButtonText]}
      />
      <VisuallyImpairedButton
        label='А'
        onPress={() => onChange(VisImpSwitchColor.Invert)}
        style={[styles.button, styles.blackColorButton]}
        textStyle={[styles.buttonText, styles.blackColorButtonText]}
      />
      <VisuallyImpairedButton
        label='А'
        onPress={() => onChange(VisImpSwitchColor.Contrast)}
        style={[styles.button, styles.blueColorButton]}
        textStyle={[styles.buttonText, styles.blueColorButtonText]}
      />
    </View>
  );
};
